<template>
  <div class="flex flex-col gap-6" data-testid="session-participants-panel">
    <div class="flex items-center justify-between gap-4">
      <div class="text-[14px] font-semibold text-text-neutral-low">
        {{ participantsCountLabel }}
      </div>
      <button
        v-if="canInvite"
        type="button"
        class="inline-flex items-center gap-2 text-primary text-sm font-medium hover:opacity-80 transition cursor-pointer shrink-0"
        @click="$emit('invite')"
        data-testid="session-participants-invite-button"
      >
        <lib-icon name="users/user-plus/outline" size="16" class="shrink-0" />
        <span>{{ $t('invite_others') }}</span>
      </button>
    </div>

    <div v-if="availableActions.includes('raiseHand') || availableActions.includes('thumbsUp') || availableActions.includes('laugh') || availableActions.includes('heart') || availableActions.includes('clap')" class="flex gap-2 overflow-x-auto pb-1">
      <button
        v-if="availableActions.includes('raiseHand')"
        type="button"
        class="inline-flex items-center justify-center rounded-full border border-transparent p-1 text-[18px] text-amber-100 transition hover:opacity-80"
        :title="$t('raise_hand') || 'Raise hand'"
        :aria-pressed="isActionActive('raiseHand') ? 'true' : 'false'"
        @click="$emit('action', 'raiseHand')"
        data-testid="participants-raise-hand-button"
        aria-label="Raise hand"
      >
        ✋
      </button>

      <button
        v-if="availableActions.includes('thumbsUp')"
        type="button"
        class="inline-flex items-center justify-center rounded-full border border-transparent p-1 text-[18px] text-emerald-100 transition hover:opacity-80"
        :title="$t('thumbs_up') || 'Thumbs up'"
        @click="$emit('action', 'thumbsUp')"
        data-testid="participants-thumbs-up-button"
        aria-label="Thumbs up"
      >
        👍
      </button>

      <button
        v-if="availableActions.includes('laugh')"
        type="button"
        class="inline-flex items-center justify-center rounded-full border border-transparent p-1 text-[18px] text-yellow-100 transition hover:opacity-80"
        :title="$t('laugh') || 'Laugh'"
        @click="$emit('action', 'laugh')"
        data-testid="participants-laugh-button"
        aria-label="Laugh"
      >
        😂
      </button>

      <button
        v-if="availableActions.includes('heart')"
        type="button"
        class="inline-flex items-center justify-center rounded-full border border-transparent p-1 text-[18px] text-rose-100 transition hover:opacity-80"
        :title="$t('heart') || 'Heart'"
        @click="$emit('action', 'heart')"
        data-testid="participants-heart-button"
        aria-label="Heart"
      >
        ❤️
      </button>

      <button
        v-if="availableActions.includes('clap')"
        type="button"
        class="inline-flex items-center justify-center rounded-full border border-transparent p-1 text-[18px] text-violet-100 transition hover:opacity-80"
        :title="$t('clap') || 'Clap'"
        @click="$emit('action', 'clap')"
        data-testid="participants-clap-button"
        aria-label="Clap"
      >
        👏
      </button>
    </div>

    <participants-list :participants="participants" />
  </div>
</template>

<script>
import LibIcon from '@/components/ui/LibIcon.vue';
import ParticipantsList from '@/components/session/ParticipantsList.vue';

export default {
  name: 'SessionParticipantsPanel',
  components: {
    LibIcon,
    ParticipantsList,
  },
  emits: ['invite', 'action'],
  props: {
    participants: {
      type: Array,
      default: () => []
    },
    participantsCount: {
      type: Number,
      default: 0
    },
    participantsLimit: {
      type: Number,
      default: 0
    },
    canInvite: {
      type: Boolean,
      default: false
    },
    availableActions: {
      type: Array,
      default: () => []
    },
    activeActions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isActionActive(action) {
      return this.activeActions.includes(action);
    }
  },
  computed: {
    participantsCountLabel() {
      if (this.participantsLimit > 0) {
        return `${this.participantsCount}/${this.participantsLimit} ${this.$t('participants')}`;
      }

      return `${this.participantsCount} ${this.$t('participants')}`;
    }
  }
}
</script>